import React from "react";
import { Modal, Button, ModalHeader } from "react-bootstrap";
// import LoadingButtonComponent from "../button/LoadingButtonComponent";
import FormikComponent from "../Formik/FormikComponent";
import FormComponent from "../Formik/FormComponent";
import * as yup from "yup";
import { emailRegx } from "../../../utils/regEx-pattern/regEx-pattern";

const validationSchema = yup.object({
    fullName: yup.string().required("Full name is required"),
    email: yup
		.string()
		.matches(emailRegx, "Please input the valid email address")
		.required("Email is required")
})

export default function SubmitConfirmationComponent(props) {
    const {modalHeader} = props;
    
    return (
        <Modal show={props.show} onHide={() => props.setShowModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalHeader}</Modal.Title>
                </Modal.Header>
                <FormikComponent
                    initialValues = {{fullName: "", email: ""}}
                    validationSchema = {validationSchema}
                    onSubmit = {() => {console.log("onsubmit")
                    props.setShowModal();
                }}
                >
                    <Modal.Body>

                        <div class="mb-3">
                            <label for="fullname" class="form-label ">Full Name</label>
                            <FormComponent type="text" name="fullName" />
                        </div>
                        <div class="mb-3">
                            <label for="email" class="form-label ">Email Address</label>
                            <FormComponent type="text" name="email" />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" class="btn btn-succ text-danger" onClick={() => props.setShowModal()}>Close</button>
                        <button type="submit" class="btn btn-pri">Submit</button>
                    </Modal.Footer>
                </FormikComponent>
            </Modal>
    );
}
